module.exports = __webpack_public_path__ + "img/kuyucuk-bg-2-2@2x.0db8950e.png";